import { CompleteOrderService } from '@complete-order/services/complete-order.service';
import { CardPaymentRedirectHelper } from '@complete-order/classes/card.payment.redirect.helper.class';
import { Address } from '@dgx-pr-spa/shared/util';
import { Contact } from '@dgx-pr-spa/shared/util';
import { CurrentPlan } from '@dgx-pr-spa/shared/util';
import { Directive, Input, OnChanges } from '@angular/core';

@Directive({
  /* eslint-disable @angular-eslint/directive-selector */
  selector: 'appCardPaymentRedirect',
})
export class CardPaymentRedirectDirective implements OnChanges {
  constructor(public completeOrderService: CompleteOrderService) {}
  @Input() currentPlan: CurrentPlan;
  @Input() replacementCost: number;
  @Input() contactDetails: Contact;
  @Input() deliveryAddress: Address;

  ngOnChanges() {
    if (this.replacementCost) {
      const request = new CardPaymentRedirectHelper(
        this.currentPlan,
        this.replacementCost,
        this.contactDetails,
        this.deliveryAddress
      ).requestBody;

      this.completeOrderService.loadCardPaymentRedirect({
        request: request,
        addressChanged: false,
      });
    } else {
      this.completeOrderService.clearPaymentRedirect();
    }
  }
}
